import { Suspense, useEffect } from 'react';
import { useBranding } from './hooks/useBranding';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { ErrorBoundary } from 'react-error-boundary';
import { Image } from '@/common/components/Image/Image';
const width = '2rem';
const height = '2rem';

export const ImagePlaceholder = styled('div')({
  width: width,
  height: height,
});

type BrandingLogoProps = {
  accountRef: number;
};

const ErrorFalbackImagePlaceholder = () => <ImagePlaceholder data-testid="errorImagePlaceHolder" />;

const BrandingImage = ({ accountRef }: BrandingLogoProps) => {
  const { data } = useBranding(accountRef);

  useEffect(() => {
    if (!data.logoUrl) {
      return;
    }

    let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = data.logoUrl;
  }, [data]);

  return <Image style={{ width, height }} src={data.logoUrl} alt="logo" />;
};

export const BrandingLogo = (props: BrandingLogoProps) => {
  return (
    <Box sx={{ height }}>
      <ErrorBoundary FallbackComponent={ErrorFalbackImagePlaceholder}>
        <Suspense fallback={<ImagePlaceholder data-testid="loadImagePlaceholder" />}>
          <BrandingImage {...props} />
        </Suspense>
      </ErrorBoundary>
    </Box>
  );
};
